/** @type {import('../schema').ProcessDefinition} */
const proveedores = {
  id: "proveedores",
  name: "Proveedores",
  category: "operaciones",
  outcome:
    "Directorio de proveedores verificados y su vínculo con cada edificio; base para órdenes de trabajo.",
  trigger:
    "El Administrador crea/asocia un proveedor; o un residente pide un servicio vía Habi.",
  actors: ["Administrador", "Sistema", "Residente", "Bot Habi"],
  status: "PARCIAL",
  description:
    "Directorio de proveedores con verificación de RUT (DGI) y asociación al edificio. El residente puede pedir un servicio y Habi sugiere proveedores; la orden de trabajo y comisión no tienen máquina de estados formal en UI.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
    { id: "bot", actor: "Bot Habi" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Alta/búsqueda en el directorio", description: "Alta o búsqueda por tipo; datos y geolocalización del proveedor.", evidence: "src/screens/admin/ProveedoresEdificio.jsx" },
    { id: "s2", laneId: "sys", type: "decision", label: "¿RUT válido?", description: "Valida el RUT con el algoritmo DGI y advierte duplicados.", evidence: "src/utils/validateRutUY.js" },
    { id: "s3", laneId: "admin", type: "task", label: "Alta manual 'no verificado'", description: "RUT inexistente: el proveedor se da de alta marcado como no verificado." },
    { id: "s4", laneId: "admin", type: "task", label: "Asocia al edificio", description: "Vincula el proveedor al edificio y define si se muestra a residentes." },
    { id: "s5", laneId: "res", type: "task", label: "Solicita un servicio", description: "El residente pide un servicio vía Habi." },
    { id: "s6", laneId: "bot", type: "handoff", label: "Sugiere proveedores del edificio", description: "Habi recomienda proveedores asociados al edificio y deriva al admin." },
    { id: "s7", laneId: "admin", type: "task", label: "Orden de trabajo / comisión", description: "Coordina el trabajo con el proveedor y, si aplica, registra la comisión como gasto. (Sin máquina de estados de OT en UI.)", evidence: "src/screens/admin/Mantenimiento.jsx" },
    { id: "s8", laneId: "admin", type: "end", label: "Proveedor operativo", description: "Proveedor activo y asociado, listo para órdenes de trabajo." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s4", label: "válido" },
    { from: "s2", to: "s3", label: "inexistente" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
  ],
};

export default proveedores;
